<script>
export default {};
</script>

<template>
  <div class="Footer-container">
    <div class="Footer">
      <b-container>
        <b-row>
          <b-col>
            <div class="Copyright">
              © {{ new Date().getFullYear() }} Navier, Inc.
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<style scoped>
.Footer-container {
  margin-top: auto;
  flex-shrink: 0;
}

.Footer {
  border-top: 1px solid rgba(0, 0, 0, 0.05);

  margin-top: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;

  color: rgba(0, 0, 0, 0.3);

  font-weight: 500;

  text-align: center;
}

@media (min-width: 768px) {
  .Footer {
    margin-top: 5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
</style>
